<template>
  <div>
    <div style="display:flex; align-items:center;">
      <el-button style="background-color: lightskyblue; margin-right: 20px;" @click="goBack">{{ $t("button.Back")
      }}</el-button>
      <h1>{{ $route.params.title }}</h1>
    </div>
    <hr />
    <br />
    <video controls controlslist="nodownload">
      <source :src="videoUrl" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
export default {
  computed: {
    videoUrl() {
      return this.$route.params.videoUrl;
    },
    title() {
      return this.$route.params.title;
    },
  },
  name: "videoPlay",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
video {
  width: 80%;
  height: auto;
}
</style>